// import {AnimatedBlob} from "./AnimatedBlob";
import Swiper from "../../external/swiper";


export class Services
{
    constructor(servicesNode)
    {
        this.root_node = servicesNode;

        if(!this.root_node) return
        // new AnimatedBlob(".services__blob path", ".services");

        this.slider    = null;

        window.addEventListener('resize', () => {
            if(window.innerWidth < 750){
                if(this.slider === null) {
                    this.init_slider();
                }
            } else {
                if(this.slider !== null) {
                    this.slider.destroy(true, true);
                    this.slider = null;
                }
            }
        });

        setTimeout(() => {
            if(window.innerWidth < 750) {
                this.init_slider();
            }
        }, 2000);
    }

    init_slider()
    {
        const slider_el = this.root_node.querySelector('.swiper-container');
        if(!!slider_el) {
            this.slider = new Swiper(slider_el, {
                speed: 500,
                slidesPerView: 'auto',
                spaceBetween: 32,
                navigation: {
                    nextEl: this.root_node.querySelector('.pagination-button--next'),
                    prevEl: this.root_node.querySelector('.pagination-button--prev')
                }
            });
        }
    }
}
